var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1650px"}},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"分发数据监控"}},[_c('DistributeDataMonitor',{ref:"DistributeDataMonitor"})],1),_c('TabPane',{attrs:{"label":"线下数据监控"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }